import { render, staticRenderFns } from "./FilterResult.vue?vue&type=template&id=180f85ec&"
import script from "./FilterResult.vue?vue&type=script&lang=js&"
export * from "./FilterResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports